// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__uPtpU","iframe":"styles_iframe__rqkAt","loadingContainer":"styles_loadingContainer__AlIRM"};